<template>
    <div v-for="(option, index) in options" :key="index">
        <div style="display: flex; align-items: center; justify-content: space-between">
            <ion-label class="ion-text-capitalize interstate-bold ion-text-wrap dark-font">{{ option.value }}</ion-label>
            <ion-row class="ion-align-items-center">
                <ion-button :disabled="option.quantity <= lowerLimit" size="small" fill="outline" shape="round" @click="updateSelectedQuantity(option, false)">
                    <ion-icon :ios="remove" :md="remove" />
                </ion-button>
                <span class="ion-margin-horizontal dark-font">{{ option.quantity }}</span>
                <ion-button :disabled="option.quantity >= option.limit" size="small" fill="outline" shape="round" @click="updateSelectedQuantity(option, true)">
                    <ion-icon :ios="add" :md="add" />
                </ion-button>
            </ion-row>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, Ref } from 'vue';
import { IonRow, IonLabel, IonButton, IonIcon } from '@ionic/vue';
import { add, remove } from 'ionicons/icons';

export interface Option {
    value: any;
    limit: any;
    quantity: any;
}

export default defineComponent({
    props: {
        options: Array<Option>,
        lowerLimit: { type: Number, default: 0 },
    },
    components: { IonButton, IonLabel, IonIcon, IonRow },
    emits: ['selectionUpdated'],
    setup(props, { emit }) {
        const updateSelectedQuantity = (option: Option, isAdd: boolean) => {
            if (option.quantity < props.lowerLimit || option.quantity > option.limit) return;

            if (isAdd) {
                option.quantity++;
            } else {
                option.quantity--;
            }
            const selectedOptions = props.options?.filter((option) => option.quantity > 0);
            emit('selectionUpdated', selectedOptions);
        };

        return { add, remove, updateSelectedQuantity };
    },
});
</script>

<style scoped>
.dense > ion-button {
    height: 24px;
    width: 24px;
    font-size: 0.8em !important;
    border: 1px;
    --border-width: 1px;
    border-radius: 10px;
    margin: 0;
}
ion-button {
    height: 36px;
    width: 36px;
    font-size: 1.1em !important;
}
ion-icon {
    position: absolute;
}
.dark-font {
    font-size: 16px;
    color: black;
}
@media screen and (max-width: 960px) {
    ion-button {
        height: 30px;
        width: 30px;
        font-size: 0.8em !important;
        --padding-start: 0;
        --padding-end: 0;
    }
}
</style>
